import ScheduleTick from './ScheduleTick';
import { strftime } from '../classes/Const';
import { createDateBeginningDay } from '../store';
const uuidv4 = require('uuid/v4');

export default class Schedule {
	get beginAsDate() {
		return this.begin.asDate;
	}
	get endAsDate() {
		return this.end.asDate;
	}
	get beginAsMinutes() {
		return this.begin.asMinutes;
	}
	get endAsMinutes() {
		return this.end.asMinutes;
	}
	get isSingleDay() {
		return this.begin.equalDCLYmd(this.end);
	}
	get isTaskSchedule() {
		return this.task_code !== '';
	}
	get isAssociatedProject() {
		return this.task_code !== '' && this.project_code !== '';
	}
	get isProjectSchedule() {
		return this.project_code !== '' && this.task_code === '';
	}
	constructor(params) {
		this.begin = params.begin;
		this.end = params.end;
		this.all_day = params.all_day;

		if (params.project_code === undefined || params.project_code === null)
			this.project_code = '';
		else
			this.project_code = params.project_code;
		
		if (params.member_code === undefined || params.member_code === null)
			this.member_code = '';
		else
			this.member_code = params.member_code;
		
		if (params.task_code === undefined || params.task_code === null)
			this.task_code = '';
		else
			this.task_code = params.task_code;
		
		if (params.code !== undefined)
			this.code = params.code;
		else
			this.code = uuidv4();
	}
	static defaultSchedule(params) {
		let target_date = new Date();
		let new_date = new Date();
		if (params.date !== undefined && params.date !== null) {
			target_date = new Date(params.date.getTime());
			target_date.setHours(new_date.getHours());
			target_date.setMinutes(new_date.getMinutes());
			target_date.setSeconds(new_date.getSeconds());
		}
		target_date.setHours(target_date.getHours() + 1);
		let begin_code = strftime('%Y%m%d%H', target_date) + "00";
		target_date.setHours(target_date.getHours() + 1);
		let end_code = strftime('%Y%m%d%H', target_date) + "00";

		return new Schedule({
			code: uuidv4(),
			begin: new ScheduleTick({ code: begin_code }), 
			end: new ScheduleTick({code: end_code }),
			project_code: params.project_code,
			member_code: params.member_code,
			task_code: params.task_code,
			all_day: true,
		});
	}

	isOverlapOneDay(date) {
		let source_date = createDateBeginningDay(date);
		let source_begin_day = ScheduleTick.createTickFromDate(source_date).asYmdHM;
		source_date.setHours(source_date.getHours() + 24);
		let source_end_day = ScheduleTick.createTickFromDate(source_date).asYmdHM;
		return !((this.begin.asYmdHM >= source_end_day
				|| this.end.asYmdHM <= source_begin_day));
	}

	isContainsDateTime(date) {
		let source_day = strftime('%Y%m%d%H%M', date);
		return (this.begin.asYmdHM <= source_day && this.end.asYmdHM >= source_day);
	}
	
	isContainsMonth(date) {
		let source_day = ScheduleTick.createTickFromDate(date).strftime('%Y%m');
		return (this.begin.strftime('%Y%m') <= source_day && this.end.strftime('%Y%m') >= source_day);
	}
	
	isAllDay(date) {
		return this.begin.isBeforeDay(date) && this.end.isAfterDay(date);
	}
	
	scheduleDayTerm() {
		let count_day = 0;
		
		let days = Math.floor((this.end.asDateYmd.getTime() - this.begin.asDateYmd.getTime() + 86400000) / 86400000);
		
		let begin = this.begin.asDateYmd;
		for (let i = 1; i <= days; i++) {
			if (this.isOverlapOneDay(begin))
				count_day++;
			begin.setDate(begin.getDate() + 1);
		}
		
		return count_day;
	}
}
